function NoDataFound() {
  return (
    <div className="flex h-[calc(100vh-100px)] w-full max-w-md items-center justify-center rounded-lg border bg-white p-2 shadow-md ">
      <h3 className="text-lg font-semibold text-gray-700">No Data Found</h3>
    </div>
  );
}

export default NoDataFound;
